import {
	EnhancedDropDownRHFWithLabel,
	EnhancedTextAreaFieldRHF,
	FieldLayout,
	LabelPosition,
	RHookFormTextFieldWithLabel,
} from "@websential/cosmic-v20";
import { payrollEarningsRl1Codes, payrollEarningsT4Codes } from "../../AdminEarningsSetup/Panels/AdminEarningsInfoSetupFieldsPanel";

import { Box, useMediaQuery, useTheme } from "@mui/material";
import { FC } from "react";
import { FieldWrapper } from "../../FieldWrapper/FieldWrapper";
import { RHookFormNumericFormatTextField } from "../../TaxSlipDataInput/RHookFormNumericFormatTextField";

interface IReimbursementsInfoSetupFieldsPanel {
		onReimbursementsSelectionChangeHandler: (value: any) => void;
	reimbursementsDDLItems: any
}
export const ReimbursementsInfoSetupFieldsPanel: FC<
	IReimbursementsInfoSetupFieldsPanel
> = ({ reimbursementsDDLItems, onReimbursementsSelectionChangeHandler }) => {

	// RESPONSIVE
		const theme = useTheme();
		const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
		const isSmallScreen = useMediaQuery(theme.breakpoints.down("md"));
		const mobileTabOrSmallLaptopScreen = isMobile || isSmallScreen;
	return (
		<Box
			sx={{
				padding: "0",
				"& .MuiTextField-root": { marginTop: 0, marginBottom: "12px" },
			}}
		>
				{mobileTabOrSmallLaptopScreen && <EnhancedDropDownRHFWithLabel
							label="Load Reimbursements"
							selectName="reimbursement"
							testId={`reimbursement`}
							labelPosition={LabelPosition.Top}
							items={reimbursementsDDLItems ?? []}
							onSelectionChangeHandler={onReimbursementsSelectionChangeHandler}
							showEmpty
						/>}
			<RHookFormTextFieldWithLabel
				label="Label"
				id="label"
				testId={`label`}
				labelPosition={LabelPosition.Top}
				// labelColumns={4}
				// fieldColumns={8}
				// required
			/>
			<EnhancedDropDownRHFWithLabel
				label="Show in Payroll"
				selectName="showInPayroll"
				testId={`Show-in-Payroll`}
				labelPosition={LabelPosition.Top}
				items={[
					{ label: "Yes", value: 200 },
					{ label: "No", value: 100 },
				]}
				selectedItem={200}
				// required
				// labelColumns={4}
				// fieldColumns={8}
			/>
			<FieldWrapper>
				<FieldLayout
					label="Max YTD"
					testId="Max-YTD"
					labelPosition={LabelPosition.Top}
					// labelColumns={4}
					// fieldColumns={8}
				>
					<RHookFormNumericFormatTextField
						id={"maxYtd"}
						testId={`maxYtd`}
						defaultValue={"0.00"}
						textAlign={"end"}
					/>
				</FieldLayout>
			</FieldWrapper>
			<EnhancedDropDownRHFWithLabel
				label="T4 Code"
				selectName="t4Code"
				testId={`T4-Code`}
				labelPosition={LabelPosition.Top}
				items={payrollEarningsT4Codes}
				labelColumns={4}
				fieldColumns={8}
			/>
			<EnhancedDropDownRHFWithLabel
				label="RL-1 Code"
				selectName="rl1Code"
				testId={`rl1Code`}
				labelPosition={LabelPosition.Top}
				items={payrollEarningsRl1Codes}
				labelColumns={4}
				fieldColumns={8}
			/>
		</Box>
	);
};
